export const CORE_OPERATIONS_CREATE_NATIVE_FS_WORKSPACE =
  'operation::@bangle.io/core-extension:CREATE_NATIVE_FS_WORKSPACE';

export const CORE_OPERATIONS_CREATE_BROWSER_WORKSPACE =
  'operation::@bangle.io/core-extension:CREATE_BROWSER_WORKSPACE';

export const CORE_OPERATIONS_CREATE_PRIVATE_FS_WORKSPACE =
  'operation::@bangle.io/core-extension:CREATE_PRIVATE_FS_WORKSPACE';

export const CORE_OPERATIONS_SERVICE_WORKER_RELOAD =
  'operation::@bangle.io/core-extension:SERVICE_WORKER_RELOAD';

export const CORE_OPERATIONS_SERVICE_WORKER_DISMISS_UPDATE =
  'operation::@bangle.io/core-extension:SERVICE_WORKER_DISMISS_UPDATE';

export const CORE_OPERATIONS_OPEN_GITHUB_ISSUE =
  'operation::@bangle.io/core-extension:CORE_OPERATIONS_OPEN_GITHUB_ISSUE';

export const CORE_OPERATIONS_REMOVE_ACTIVE_WORKSPACE =
  'operation::@bangle.io/core-extension:REMOVE_ACTIVE_WORKSPACE';

export const CORE_OPERATIONS_NEW_NOTE =
  'operation::@bangle.io/core-extension:NEW_NOTE';

export const CORE_OPERATIONS_NEW_WORKSPACE =
  'operation::@bangle.io/core-extension:NEW_WORKSPACE';

export const CORE_OPERATIONS_TOGGLE_EDITOR_SPLIT =
  'operation::@bangle.io/core-extension:TOGGLE_EDITOR_SPLIT';
export const CORE_OPERATIONS_OPEN_IN_MINI_EDITOR =
  'operation::@bangle.io/core-extension:OPEN_IN_MINI_EDITOR';
export const CORE_OPERATIONS_CLOSE_MINI_EDITOR =
  'operation::@bangle.io/core-extension:CLOSE_MINI_EDITOR';

export const CORE_OPERATIONS_CLOSE_EDITOR =
  'operation::@bangle.io/core-extension:CLOSE_EDITOR';
